// extracted by mini-css-extract-plugin
export default {"description":"PungoSlider_description__oCQH2","sliderContainer":"PungoSlider_sliderContainer__IhO+s","sliderValue":"PungoSlider_sliderValue__PemMx"};